import * as tslib_1 from "tslib";
import React from 'react';
import { compose } from 'redux';
import classnames from 'classnames';
import omit from 'lodash.omit';
import { Trans, withTranslation } from 'react-i18next';
import FormPopup from '../Popup/Form';
import IconButton from '../Button/IconButton';
import IconClose from '../Icons/CloseBold';
import IconTrashcan from '../Icons/Trashcan';
import { IconSize } from '../Icons/IconWrap';
import ConfirmationPopup from '../Popup/ConfirmationPopup';
import ProgressBar from './ProgressBar';
import { EditorFlavourConfigs } from '../DaEditorWrapper/config';
import DaEditorWrapper from '../DaEditorWrapper/LoadableDaEditorWrapper';
import { WORD_COUNT_FEATURE } from '../DaEditorWrapper/Features/wordCount';
import { IS_EMPTY_FEATURE } from '../DaEditorWrapper/Features/isEmpty';
import { getFeature } from '../DaEditorWrapper/Features';
import { convertToClientStorageState, hasChanged, } from '../DaEditorWrapper/utils';
import { withMobileContext } from '../Context';
import reduxConnectContainer from './StatusEditPopup.container';
import mergeTheme from '../DaEditorWrapper/Themes/mergeTheme';
// Merge the text theme with the editor theme (content vs editor toolbars etc)
import textTheme from '../DaEditorWrapper/Themes/Viewer/status.scss';
import editorTheme from '../DaEditorWrapper/Themes/Editor/status.scss';
var statusTheme = mergeTheme(textTheme, editorTheme);
import s from './StatusEditPopup.scss';
import { MAXIMUM_SHORT_STATUS_LENGTH, MAXIMUM_LONG_STATUS_LENGTH, MAXIMUM_STATUS_LENGTH, MINIMUM_STATUS_LENGTH, NUMBER_OF_TIMES_TO_SHOW_TUTORIAL_SUBTITLE, } from './constants';
import { MEDIA_COUNT_FEATURE } from '../DaEditorWrapper/Features/mediaCount';
import LoadingIndicator from '../LoadingIndicator';
var defaultState = {
    statusId: undefined,
    canSubmit: false,
    isEditorEmpty: true,
    isShortStatus: true,
    hasUnsavedChanges: false,
    showDiscardChangesPopup: false,
    charactersEntered: 0,
    alertDismissed: false,
    footerToolbar: null,
    editorApi: null,
};
var enhance = compose(reduxConnectContainer, withMobileContext, withTranslation());
var StatusEditPopup = /** @class */ (function (_super) {
    tslib_1.__extends(StatusEditPopup, _super);
    function StatusEditPopup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = tslib_1.__assign({}, defaultState, { selectionState: _this.props.selectionState, hasUnsavedChanges: _this.props.hasUnsavedChanges });
        _this.handleClose = function () {
            if (_this.state.isEditorEmpty) {
                _this.props.onClose();
            }
            else {
                _this.showDiscardChangesPopup();
            }
        };
        _this.handleSubmit = function () {
            var editorContent = _this.editorContent;
            var editorRawState = _this.editorRawState;
            var features = _this.editorFeatures;
            var statusId = _this.state.statusId;
            _this.props.submitStatus({
                editorContent: editorContent,
                editorRawState: editorRawState,
                features: features,
                statusId: statusId,
            });
            _this.increaseSubmitCounter();
        };
        _this.handleInitialContent = function (contentState, raw) {
            _this.initialContentState = contentState;
            _this.initialRawState = raw;
        };
        _this.handleEditorChange = function (rawContentState, editorContent, featuresData, selectionState) {
            _this.editorRawState = rawContentState;
            _this.editorContent = editorContent;
            _this.handleEditorFeatureChange(featuresData, selectionState);
        };
        _this.handleEditorFeatureChange = function (features, selectionState) {
            _this.editorFeatures = features;
            var newState = {};
            // Features
            var wordCount = getFeature(WORD_COUNT_FEATURE, features);
            var mediaCount = getFeature(MEDIA_COUNT_FEATURE, features);
            var isEmptyFeature = getFeature(IS_EMPTY_FEATURE, features);
            var isEditorEmpty = isEmptyFeature ? isEmptyFeature.data.isEmpty : true;
            // Counts
            var charactersEntered = wordCount && wordCount.data.chars;
            var hasNoMedia = mediaCount &&
                (mediaCount.data.images === 0 && mediaCount.data.video === 0);
            // State
            var isShortStatus = charactersEntered <= MAXIMUM_SHORT_STATUS_LENGTH && hasNoMedia;
            var canSubmit = !isEditorEmpty &&
                charactersEntered >= MINIMUM_STATUS_LENGTH &&
                charactersEntered < MAXIMUM_STATUS_LENGTH;
            var hasUnsavedChanges = _this.initialContentState &&
                hasChanged(_this.initialContentState, _this.initialRawState, _this.editorContent, _this.editorRawState)
                ? true
                : _this.props.hasUnsavedChanges;
            newState = tslib_1.__assign({}, newState, { canSubmit: canSubmit,
                isShortStatus: isShortStatus,
                hasUnsavedChanges: hasUnsavedChanges,
                charactersEntered: charactersEntered,
                isEditorEmpty: isEditorEmpty });
            // Handle switching between short and long
            if (newState.isShortStatus !== _this.state.isShortStatus) {
                _this.editorSwitchModeState = convertToClientStorageState(_this.editorRawState, _this.editorContent, features).editorText;
                newState.footerToolbar = undefined;
                newState.selectionState = selectionState.toJSON();
            }
            _this.setState(newState);
        };
        _this.showDiscardChangesPopup = function () {
            _this.setState({
                showDiscardChangesPopup: true,
            });
        };
        _this.handleDiscardChanges = function () {
            _this.setState({
                showDiscardChangesPopup: false,
            }, _this.props.onClose);
        };
        _this.handleCancelConfirmation = function () {
            _this.setState({
                showDiscardChangesPopup: false,
            });
        };
        _this.handleSwitchToJournalMode = function () {
            var _a = _this.state, editorApi = _a.editorApi, hasUnsavedChanges = _a.hasUnsavedChanges;
            _this.props.onSwitchMode &&
                _this.props.onSwitchMode(_this.editorRawState, _this.editorContent, _this.editorFeatures, hasUnsavedChanges, editorApi && editorApi.getCurrentSelection().toJSON());
        };
        _this.handleDismissAlert = function () {
            if (_this.props.error) {
                return _this.props.submitStatusFailureDismiss();
            }
            _this.setState({
                alertDismissed: true,
            });
        };
        _this.handleEditorReady = function (toolbars, api) {
            _this.setState({
                footerToolbar: _this.props.isMobile ? toolbars.SIDE : toolbars.FOOTER,
                editorApi: api,
            });
        };
        return _this;
    }
    StatusEditPopup.getDerivedStateFromProps = function (props, state) {
        var deviation = props.deviation, hasUnsavedChanges = props.hasUnsavedChanges;
        if (deviation && deviation.deviationId !== state.statusId) {
            var statusId = deviation.deviationId;
            return tslib_1.__assign({}, defaultState, { hasUnsavedChanges: hasUnsavedChanges,
                statusId: statusId });
        }
        return null;
    };
    StatusEditPopup.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            this.renderFormPopup(),
            this.renderConfirmationPopup()));
    };
    StatusEditPopup.prototype.renderFormPopup = function () {
        var _a = this.props, t = _a.t, editorInitState = _a.editorInitState, deviation = _a.deviation, isMobile = _a.isMobile, isSubmitting = _a.isSubmitting;
        var _b = this.state, isShortStatus = _b.isShortStatus, canSubmit = _b.canSubmit, selectionState = _b.selectionState;
        var initialContent = this.editorSwitchModeState ||
            (deviation && deviation.textContent) ||
            editorInitState;
        this.editorSwitchModeState = undefined; // Use it once only
        return (React.createElement(FormPopup, { isOpen: true, className: classnames(s['root'], isShortStatus ? s['short-status-editor'] : s['long-status-editor']), title: this.renderPopupTitle(), headerExtras: isMobile ? this.renderMobileHeaderExtras() : this.renderHeaderExtras(), headerClassName: classnames(s['header'], isShortStatus && s['header-short'], this.shouldRenderSubtitle() && s['header-with-subtitle']), footerExtras: !isMobile && this.renderFooterExtras(), footerClassName: s['footer'], contentClassName: classnames(s['content'], isShortStatus && s['content-short-status']), contentWrapperClassName: s['content-wrapper'], headerStickyClassName: s['header-sticky'], submitBtnLabel: t('popup.submit'), disabledSubmit: !canSubmit || isSubmitting, onSubmit: this.handleSubmit, onCancel: this.handleClose, onClose: this.handleClose, withContentPaddings: false, withCloseButton: !isMobile, withCancelBtn: isMobile },
            isShortStatus && (React.createElement(ShortEditor, tslib_1.__assign({ isMobile: isMobile, handleEditorChange: this.handleEditorChange, handleEditorReady: this.handleEditorReady, editorInitState: initialContent, handleSubmit: this.handleSubmit, selectionState: selectionState, handleInitialContent: this.handleInitialContent }, omit(this.props, ['editorInitState', 'selectionState'])))),
            !isShortStatus && (React.createElement(LongEditor, tslib_1.__assign({ isMobile: isMobile, handleEditorChange: this.handleEditorChange, handleEditorReady: this.handleEditorReady, editorInitState: initialContent, handleSubmit: this.handleSubmit, selectionState: selectionState, handleInitialContent: this.handleInitialContent }, omit(this.props, ['editorInitState', 'selectionState']))))));
    };
    StatusEditPopup.prototype.renderConfirmationPopup = function () {
        var t = this.props.t;
        return (React.createElement(ConfirmationPopup, { isOpen: this.state.showDiscardChangesPopup, title: t('statusUpdate.confirm.discardChanges'), text: t('statusUpdate.confirm.discardChangesText'), confirmBtnType: "danger", confirmBtnLabel: t('popup.discard'), onCancel: this.handleCancelConfirmation, onConfirm: this.handleDiscardChanges, icon: React.createElement(IconTrashcan, { size: IconSize.HUGE }) }));
    };
    StatusEditPopup.prototype.renderPopupTitle = function () {
        var _a = this.props, t = _a.t, isMobile = _a.isMobile;
        if (isMobile) {
            return '';
        }
        return React.createElement("div", { className: s['title'] }, t('statusUpdate.statusUpdate'));
    };
    StatusEditPopup.prototype.renderPopupSubtitle = function () {
        return (React.createElement("div", { className: s['subtitle'] },
            React.createElement(Trans, { i18nKey: "statusUpdate.subtitle" },
                "Share your thoughts, ideas and feelings. Want to put in a story or an article? Try",
                React.createElement("a", { className: s['text-link'], onClick: this.handleSwitchToJournalMode }, "Journal"),
                ".")));
    };
    StatusEditPopup.prototype.renderHeaderExtras = function () {
        if (!this.canSwitchToJournal()) {
            return null;
        }
        return this.shouldRenderSubtitle()
            ? this.renderPopupSubtitle()
            : this.renderModeSwitcher();
    };
    StatusEditPopup.prototype.shouldRenderSubtitle = function () {
        // The first ${NUMBER_OF_TIMES_TO_SHOW_TUTORIAL_SUBTITLE} times the user submits a status
        // we need to show a subtitle that informs the user about switching to journal mode.
        // After the we just show a small "Switch to journal" link next to the close button.
        return this.getSubmitCounter() < NUMBER_OF_TIMES_TO_SHOW_TUTORIAL_SUBTITLE;
    };
    StatusEditPopup.prototype.renderMobileHeaderExtras = function () {
        var t = this.props.t;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: s['mobile-header-wrap'] },
                React.createElement("div", { className: s['mobile-header-title-tools'] },
                    React.createElement("div", null, t('statusUpdate.statusUpdate')),
                    React.createElement("div", { className: s['mobile-tools'] }, this.renderFooterToolbar())),
                this.renderProgressBar())));
    };
    StatusEditPopup.prototype.canSwitchToJournal = function () {
        return this.props.onSwitchMode && !this.props.deviation;
    };
    StatusEditPopup.prototype.renderModeSwitcher = function () {
        return (React.createElement("div", { className: s['mode-switcher'] },
            React.createElement(Trans, { i18nKey: "statusUpdate.switchTo.journal" },
                "Switch to",
                React.createElement("a", { className: s['text-link'], onClick: this.handleSwitchToJournalMode }, "Journal"))));
    };
    StatusEditPopup.prototype.renderFooterExtras = function () {
        return (React.createElement(React.Fragment, null,
            this.renderProgressBar(),
            this.renderAlerts(),
            this.renderFooterToolbar()));
    };
    StatusEditPopup.prototype.renderFooterToolbar = function () {
        var footerToolbar = this.state.footerToolbar;
        if (!footerToolbar) {
            return;
        }
        var FooterToolbar = footerToolbar;
        return (React.createElement("div", { className: s['footerToolbar'] },
            React.createElement(FooterToolbar, null)));
    };
    StatusEditPopup.prototype.renderProgressBar = function () {
        var percentage = (this.state.charactersEntered / MAXIMUM_SHORT_STATUS_LENGTH) * 100;
        return React.createElement(ProgressBar, { className: s['progressbar'], percentage: percentage });
    };
    StatusEditPopup.prototype.renderAlerts = function () {
        if (this.props.error) {
            return this.renderAlert(this.props.error, s['alert-error']);
        }
        return this.renderSwitchToJournalAlert();
    };
    StatusEditPopup.prototype.renderSwitchToJournalAlert = function () {
        if (!this.canSwitchToJournal()) {
            return null;
        }
        var _a = this.state, alertDismissed = _a.alertDismissed, charactersEntered = _a.charactersEntered;
        if (alertDismissed || charactersEntered < MAXIMUM_LONG_STATUS_LENGTH) {
            return null;
        }
        var message = (React.createElement(Trans, { i18nKey: "statusUpdate.alert.switchToJournal" },
            "Turn this post into a",
            ' ',
            React.createElement("a", { onClick: this.handleSwitchToJournalMode }, "journal"),
            " to get more cool customization features"));
        return this.renderAlert(message);
    };
    StatusEditPopup.prototype.renderAlert = function (message, className) {
        if (className === void 0) { className = s['alert-info']; }
        return (React.createElement("div", { className: classnames(s['alert'], className) },
            React.createElement("div", { className: s['alert-message'] }, message),
            React.createElement(IconButton, { onClick: this.handleDismissAlert, noHoverEffect: true },
                React.createElement(IconClose, { className: s['alert-close'] }))));
    };
    StatusEditPopup.prototype.getSubmitCounter = function () {
        return (parseInt(String(localStorage.getItem('statusUpdateSubmitCounter'))) || 0);
    };
    StatusEditPopup.prototype.increaseSubmitCounter = function () {
        var counter = this.getSubmitCounter();
        localStorage.setItem('statusUpdateSubmitCounter', String(counter + 1));
    };
    return StatusEditPopup;
}(React.Component));
export { StatusEditPopup };
var ShortEditor = function (props) {
    return (React.createElement("div", { className: "da-editor-status da-editor-status-short" },
        React.createElement(DaEditorWrapper, { loadingComponent: LoadingIndicator, flavour: EditorFlavourConfigs.STATUS_SHORT, onEditorInit: props.handleEditorReady, autoFocus: !props.isMobile, theme: statusTheme, selectionState: props.selectionState, editorKey: "statusBodyShort", placeholder: props.t('statusUpdate.placeholder'), onContentChange: props.handleEditorChange, onInitialContentReady: props.handleInitialContent, initialContent: props.editorInitState, fixedParagraph: false, filterPaste: true, onKeyboardSubmit: props.handleSubmit })));
};
var LongEditor = function (props) {
    return (React.createElement("div", { className: "da-editor-status da-editor-status-long" },
        React.createElement(DaEditorWrapper, { loadingComponent: LoadingIndicator, flavour: EditorFlavourConfigs.STATUS_LONG, onEditorInit: props.handleEditorReady, selectionState: props.selectionState, autoFocus: !props.isMobile, theme: statusTheme, editorKey: "statusBodyLong", placeholder: props.t('statusUpdate.placeholder'), onContentChange: props.handleEditorChange, onInitialContentReady: props.handleInitialContent, initialContent: props.editorInitState, fixedParagraph: false, filterPaste: true, onKeyboardSubmit: props.handleSubmit })));
};
export default enhance(StatusEditPopup);
//# sourceMappingURL=StatusEditPopup.js.map